import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, FlaskConical, ShoppingBag, Clock, Star } from 'lucide-react';
export function ValueStack() {
  const items = [{
    icon: <BookOpen size={24} data-id="element-187" />,
    title: 'Guía Digital "Piel de Seda"',
    desc: 'El manual paso a paso con la técnica de la Ósmosis Botánica.',
    highlight: false
  }, {
    icon: <FlaskConical size={24} data-id="element-188" />,
    title: '5 Recetas Maestras',
    desc: 'Fórmulas exactas para Limpieza, Detox, Nutrición, Calma y Regeneración.',
    highlight: false
  }, {
    icon: <ShoppingBag size={24} data-id="element-189" />,
    title: 'Checklist de Compra Inteligente',
    desc: 'Los 10 ingredientes básicos que transformarán tu baño en un boticario.',
    highlight: false
  }, {
    icon: <Clock size={24} data-id="element-190" />,
    title: 'Protocolo de 21 Días',
    desc: 'El calendario exacto para ver cambios reales en la textura de tu rostro y cuerpo.',
    highlight: false
  }, {
    icon: <Star size={24} data-id="element-191" />,
    title: 'BONUS: Guía de Aceites Esenciales',
    desc: 'Para elevar tu estado de ánimo mientras cuidas tu piel.',
    highlight: true
  }];
  return <section className="py-24 px-4 bg-botanical-ivory" data-id="element-192">
      <div className="max-w-4xl mx-auto" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-194">
          <h2 className="text-3xl md:text-4xl font-playfair text-botanical-forest mb-4" data-id="element-195">
            Todo lo que necesitas para tu transformación
          </h2>
          <div className="w-24 h-px bg-botanical-gold mx-auto" data-id="element-196"></div>
        </motion.div>

        <div className="space-y-6" data-id="element-197">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`flex flex-col md:flex-row items-start md:items-center gap-6 p-6 md:p-8 rounded-sm bg-white shadow-sm transition-all duration-300 ${item.highlight ? 'border-2 border-botanical-gold relative overflow-hidden' : 'border border-botanical-sage/20'}`} data-id="element-198">
              {item.highlight && <div className="absolute top-0 right-0 bg-botanical-gold text-white text-xs font-bold px-3 py-1 uppercase tracking-wider" data-id="element-199">
                  Regalo Especial
                </div>}

              <div className={`p-4 rounded-full shrink-0 ${item.highlight ? 'bg-botanical-gold/10 text-botanical-gold' : 'bg-botanical-sage/10 text-botanical-sage'}`} data-id="element-200">
                {item.icon}
              </div>

              <div data-id="element-201">
                <h3 className={`text-xl font-playfair mb-2 ${item.highlight ? 'text-botanical-gold' : 'text-botanical-forest'}`} data-id="element-202">
                  {item.title}
                </h3>
                <p className="text-botanical-forest/70 font-lora" data-id="element-203">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}